import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import { PageTitle } from '@components/shared/PageTitle'
import { CreatorListItemComponent } from '@components/Creator/CreatorListItem'
import type { CreatorInfoPropsType, CreatorListPropsType } from '../../models/Creator'

export function CreatorList (props: CreatorListPropsType): React.ReactNode {
  return (
    <CreatorPage>
      <PageTitle title={props.title} />
      <PageDescriptionContainer>{props.description}</PageDescriptionContainer>
      <CreatorListContainer>
      {props.creators.map((creator: CreatorInfoPropsType): React.ReactNode => (
        <CreatorListItemComponent {...creator} key={creator.id}/>
      ))}
      </CreatorListContainer>
    </CreatorPage>
  )
}

const CreatorPage = styled.div<any>`
    display: flex;
    flex-direction: column;
`
const PageDescriptionContainer = styled.div<any>`
    font-family: "Good Sans Regular";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px; /* 130.769% */
    letter-spacing: -0.3px;
    color: ${colors.white};
    margin-bottom: 16px;
    
    ${(props: any): any => config(props).media.md`
      font-size: 16px;
    `}
`
const CreatorListContainer = styled.div<any>`
    display: flex;
    flex-direction: column;
    
    ${(props: any): any => config(props).media.lg`
    flex-direction: row;
      flex-wrap: wrap;
      gap: 40px;
      &>* {
          flex: 1 1 44%;
      }
  `}
`
